module.exports = __webpack_public_path__ + "static/media/creamy_mint.56c88971.png";